import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const alexaI18nImporterSelectors = importerSelectors(
  'alexaI18n.importer',
);

export default alexaI18nImporterSelectors;
